import request from 'superagent';
import moment from 'moment';

const get = query =>
	new Promise((resolve, reject) => {
		request
		.get(`/api/${query}`)
		.accept('application/json')
		.end((err, res) => {
			if (err) { reject(err); }
			else { resolve(JSON.parse(res.text).data); }
		});
	});

export const getMeetingsByDate = (date = moment().add(1, 'day').format('YYYY-MM-DD')) => dispatch =>
	get(`board?date=${date}`).then(
		meetings => dispatch({
			type: 'LIST_MEETINGS',
			meetings: meetings.sort((a, b) => {
				if (a.venue > b.venue) return 1;
				if (a.venue < b.venue) return -1;
				return 0;
			}),
			date,
		})
	);


/** WEBPACK FOOTER **
 ** ./src/api.js
 **/